import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import AcceptedQuoteOceanUserDetails from '../components/AcceptedQuoteDetails/AcceptedQuoteOceanUserDetails'
import AcceptedQuoteOceanUserDetailsKAM from '../../components/Admin/AcceptedQuoteDetails/AcceptedQuoteOceanUserDetailsKAM'
// import AcceptedQuoteUserDetails from '../components/AcceptedQuoteDetails/AcceptedQuoteUserDetails'
import AcceptedQuoteUserDetailsKAM from '../../components/Admin/AcceptedQuoteDetails/AcceptedQuoteUserDetailsKAM'
import ContentHead from '../../components/Admin/Common/ContentHead'
import OceanViewPage from '../../components/Admin/Queries/OceanViewPage'
import ViewPage from '../../components/Admin/Queries/ViewPage'
import UserDetails from '../../components/Admin/UserManagement/UserDetails'
import KamUserKycTable from '../../components/Admin/UserManagement/KamUserKycTable'
import { get_user_list } from '../../store/Admin/UserManagement/UserManagementSlice'
import { authuser } from '../../store/Authentication/AuthSlice'
import { LeftHead, SubHeadContainer, SubHeadTitle } from '../../StyledComponents/Common'
import {  ContentContainer, TableTitle, TableTop } from '../../StyledComponents/CreateKeyAccountManager'
import { MainContainer } from '../../StyledComponents/Dashboard'
import { IconImg } from '../../StyledComponents/Header'
import { FilterSection } from '../../StyledComponents/Queries'
import SearchBox from '../../components/Admin/Common/SearchBox'
let debounceTimer = null;
function UserManagement() {
    const dispatch = useDispatch()
    const loginedUser = useSelector(authuser);
    const [pageType, setPageType] = useState("table");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentTab, setCurrentTab] = useState("1");
    const [pageSize, setPageSize] = useState(10);
    const [instance] = useState({});
    const [query_instance, setQueryInstance] = useState({});
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true)

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Server-side pagination: kam/kam_users_list?page=&limit=&search=
    useEffect(()=>{
        if(pageType !== 'table') return;
        // Ignore responses from superseded requests (older page/search).
        let stale = false;
        setQueryInstance({})
        const queryStringObj = { page: currentPage, limit: pageSize };
        if (search) queryStringObj.search = search;
        setLoading(true)
        dispatch(get_user_list(`?${new URLSearchParams(queryStringObj).toString()}`))
        .then(res=>{
            if(stale) return;
            if(res?.payload?.data?.statusCode === 200 ){
                setData(res?.payload?.data?.data || [])
                setTotal(res?.payload?.data?.pagination?.total || 0)
            }
        })
        .catch(err=>{
            console.error(err);
        })
        .finally(()=> { if(!stale) setLoading(false) })
        return () => { stale = true }
    },[pageType, currentPage, pageSize, search, dispatch])

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setCurrentPage(1);
    };


    const handleBackArrow = () => {
        if(query_instance.status === 'Booked'){
            setCurrentTab("2")
          }else if(query_instance.status === 'Quoted'){
            setCurrentTab("3")
          }
          setQueryInstance({})
      }


    const onSearch = (value) => {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            setSearch(value?.trim() || "");
            setCurrentPage(1);
        }, 700);
      };

  return (
    <MainContainer>
      {pageType === 'table'? <>
        <div className="tableResponsiveASAP">
        <ContentContainer>
            <TableTop>
                <TableTitle>User List</TableTitle>
                 <FilterSection className="filter">
                                    <SearchBox onSearch={onSearch} />
                                  </FilterSection>
            </TableTop>
            <KamUserKycTable
                data={data}
                total={total}
                currentPage={currentPage}
                pageSize={pageSize}
                loading={loading}
                kamName={loginedUser?.full_name}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
            />
        </ContentContainer>
        </div>
      </>
        :pageType === 'view_page'? 
        <>
            {query_instance?.queryId? 
                query_instance.status === "Quoted" ? 
                    query_instance.queryType === 'Ocean Manual' || query_instance.queryType === 'Ocean Automatic'?
                        <OceanViewPage setPageType={setPageType} instance={query_instance} parent_type="user_management" setQueryInstance={setQueryInstance} setCurrentTab={setCurrentTab} />:
                        <ViewPage setPageType={setPageType} instance={query_instance} parent_type="user_management" setQueryInstance={setQueryInstance} setCurrentTab={setCurrentTab} />
                         :
                    <ContentContainer>
                        <SubHeadContainer className='flex-column'>
                            <LeftHead>
                                <IconImg onClick={()=> handleBackArrow()} src={require('../../assets/admin/images/back_page_arrow.png')} />
                                <SubHeadTitle>Details</SubHeadTitle>
                            </LeftHead>
                        </SubHeadContainer>
                        {query_instance.queryType === 'Ocean Manual' || query_instance.queryType === 'Ocean Automatic'?
                            <AcceptedQuoteOceanUserDetailsKAM instance={query_instance} setQueryInstance={setQueryInstance} setPageType={setPageType} />
                        :
                            <AcceptedQuoteUserDetailsKAM instance={query_instance} setQueryInstance={setQueryInstance} setPageType={setPageType} />
                        }
                        {/* <AcceptedQuoteUserDetailsKAM instance={query_instance} setQueryInstance={setQueryInstance} setPageType={setPageType} /> */}
                    </ContentContainer>
            : 
            <ContentContainer>
                <ContentHead title="User Details"  handleClick={()=> setPageType("table")} />
                <UserDetails instance={instance} setQueryInstance={setQueryInstance} tab={currentTab} setPageType={setPageType} />
            </ContentContainer> }
            
        </>
       
        
        : null}
      
      
    </MainContainer>
  )
}

export default UserManagement
